import ViewViewModel from '@/ViewModels/ViewViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';

/**
 * Repräsentiert das ViewModel des Footers
 */
export default class FooterViewModel extends ViewViewModel {

    public constructor(params: CoreFrameInterfaces.FooterViewModelConstructorParameter) {
        super(params);
    }
}

ComponentManager.setViewModel('FooterViewModel', FooterViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');